import React, {useEffect, useState} from 'react';
import {Input} from "semantic-ui-react";

const InputTwoValues = ({separator = ' — ', value1, value2, onChange, disabled}) => {

    const [values, setValues] = useState('');

    useEffect(() => {
        const v = `${value1 || ''}${value2 ? separator : ''}${value2 || ''}`;
        if (v !== values) setValues(v);
    }, [value1, value2]);

    const onChangeValues = (value) => {
        const arrayValues = value.split(separator);
        if (arrayValues.length === 1 && arrayValues[0].length > 1) {
            let last = value.slice(-1);
            const separators = [' ', '-', '—'];
            if (separators.includes(last) && (value.length > values.length)) {
                value = value.slice(0, -1) + separator;
                arrayValues[0] = arrayValues[0].slice(0, -1);
            }
        }
        const re = new RegExp(/^[+-]?\d*([.,]\d*)?$/);
        const isValid = arrayValues.length <= 2 && arrayValues.every(v => re.test(v.trim()) || v === '');
        if (isValid) {
            // Заменяем запятую на точку в значениях для корректной обработки
            const normalizedValue1 = arrayValues[0].trim().replace(',', '.');
            const normalizedValue2 = arrayValues[1] ? arrayValues[1].trim().replace(',', '.') : null;
            onChange(normalizedValue1, normalizedValue2);
            setValues((arrayValues.length === 1 || (arrayValues.length === 2 && arrayValues[1] === '')) ? value : value.trim())
        }
    }

    return (
        <Input
            disabled={disabled}
            type='text'
            value={values}
            onChange={(e, {value}) => onChangeValues(value)}
        />
    );
};

export default InputTwoValues;


// WEBPACK FOOTER //
// ./App/components/InputTwoValues.jsx